import CollectionPayload from '@libraries/api/post';
import CollectionTags from '@libraries/api/tag';
import FetchData from '@utils/fetch-data';
import { notification } from 'antd';
import { history, IFetchData, initialList } from 'asumsi-components';
import { Dispatch, SetStateAction, useState } from 'react';
import { IResponsePost } from '@interfaces/iresponse-post';
import { IResponseTag } from "@interfaces/iresponse-tag";

const initialData = initialList.data;
const initialMeta = initialList.meta;
const defaultPage: number = 1;

export default function useAction() {
    const [isLoader, setIsLoader]: [boolean, Dispatch<SetStateAction<boolean>>] = useState(false);
    const [data, setData]: [
        IResponsePost[],
        Dispatch<SetStateAction<IResponsePost[]>>,
    ] = useState(initialData);

    const [detail, setDetail]: [
        any,
        Dispatch<SetStateAction<any>>,
    ] = useState();

    const [tags, setTags]: [
        IResponseTag[],
        Dispatch<SetStateAction<IResponseTag[]>>,
    ] = useState(initialData);

    const [metaData, setMeta]: [
        any,
        Dispatch<SetStateAction<any>>,
    ] = useState(initialMeta);

    const getData = async (params: any) => {
        const payload: IFetchData = CollectionPayload.read(params);

        setIsLoader(true);
        try {
            const response: any = await FetchData({ ...payload });
            setData(response.data.data);
            setMeta(response.data.meta);
            setIsLoader(false);
        } catch (error) {
            const { response } = error;
            setData(initialData);
            setMeta(initialMeta);
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const getTags = async (params: any) => {
        const payload: IFetchData = CollectionTags.read(params);

        setIsLoader(true);
        try {
            const response: any = await FetchData({ ...payload });
            setTags(response.data.data);
            setIsLoader(false);
        } catch (error) {
            const { response } = error;
            setTags(initialData);
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const getDetail = async (id: string) => {
        const payload: IFetchData = CollectionPayload.readOne(id);

        setIsLoader(true);

        try {
            const response: any = await FetchData({ ...payload });
            setIsLoader(false);
            setDetail(response.data.data)
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };



    const postData = async (params: any) => {
        const param = new FormData()
        Object.keys(params).map((key: any) => param.append(key, params[key]));
        const payload: IFetchData = CollectionPayload.post(param);

        setIsLoader(true);

        try {
            await FetchData({ ...payload });
            setIsLoader(false);
            notification.success({
                message: 'Berhasil',
                duration: 5,
                description: 'Berhasil simpan data',
            });
            history.push({
                pathname: '/article/posts',
            });
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal menyimpan data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const updateData = async (params: any, id: string) => {
        const param = new FormData()
        Object.keys(params).map((key: any) => param.append(key, params[key]));
        const payload: IFetchData = CollectionPayload.put(param, id);

        setIsLoader(true);

        try {
            await FetchData({ ...payload });
            setIsLoader(false);
            notification.success({
                message: 'Berhasil',
                duration: 5,
                description: 'Berhasil simpan data',
            });
            history.push({
                pathname: '/article/posts',
            });
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal menyimpan data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const deleteData = async (id: string) => {
        const payload: IFetchData = CollectionPayload.delete(id);
        setIsLoader(true);

        try {
            await FetchData({ ...payload });
            setIsLoader(false);
            notification.success({
                message: 'Success',
                duration: 5,
                description: "berhasil hapus data",
            });
        } catch (error) {
            setIsLoader(false);
            notification.error({
                description: "gagal hapus data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    return {
        data,
        defaultPage,
        getData,
        isLoader,
        setIsLoader,
        postData,
        metaData,
        getDetail,
        updateData,
        deleteData,
        getTags,
        tags,
        detail
    };
}



// WEBPACK FOOTER //
// ./src/pages/post/hooks/useAction.tsx